import { getSearchParams } from '../utils/helper';

export const useIsClipView = () => {
  const searchParams = getSearchParams();
  const clipId = searchParams.get('video');
  const eventId = searchParams.get('event');

  const isClipView = Boolean(clipId || eventId);

  return isClipView;
};
